import NavBar from "../../components/nav_bar";
import { Link } from "react-router-dom";
import Notepad from "../../components/notepad";
import t from "../../locales";
import YouShareImageCard from "../../components/you_share_image_card";
import youShareIcon from "../../assets/images/you_share.png";
import backIcon from "../../assets/images/you_share/arrow_back_ios_new.svg";
import { pictures } from "../../store/pictures";

export default function YouShareDetails() {
  return (
    <div>
      <NavBar icon={youShareIcon} />
      <div className="you-share-account">
        <div className="you-share-account__top">
          <Link
            to="/youshare?ignoreMessage=true"
            className="you-share-acount__back"
          >
            <img src={backIcon} />
          </Link>
          <div className="you-share-account__name">{t("youshare_name")}</div>
          <span className="you-share-account__extra">...</span>
        </div>
      </div>
      <div className="you-share-pictures--flow">
        {pictures.map((picture) => (
          <YouShareImageCard picture={picture} key={picture.key} />
        ))}
      </div>
      <Notepad />
    </div>
  );
}
